import { render } from "./DansukDigitalHome.vue?vue&type=template&id=1a90bb12&scoped=true"
import script from "./DansukDigitalHome.vue?vue&type=script&lang=js"
export * from "./DansukDigitalHome.vue?vue&type=script&lang=js"

import "./DansukDigitalHome.vue?vue&type=style&index=0&id=1a90bb12&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a90bb12"]])

export default __exports__